module.exports = "https://cdn.hellotech.com/client-assets/HT-fees-hdr_4fc295f16ffe834e03d1da10f991a8fe.jpg";